"use strict";

require('./callbacks/sweetalert2');
